exports = module.exports = require("../../../ext-web-comp-script/node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".popup-444af481{display:none;width:200px;height:200px;position:absolute;z-index:999}.popup-444af481 section,.popup-444af481 iframe{width:100%;height:100%}\n", ""]);

// Exports
exports.locals = {
	"popup": "popup-444af481"
};